<template>
  <a-input class="pt-input" autocomplete="off" :maxlength="$attrs.type != 'textarea' ?100:500" :placeholder="placeholder?placeholder:$t('baseVO.inputPlaceholder')"  v-model.trim="inputValue"  v-bind="$attrs" v-on="$listeners">
    <template slot="addonAfter">
      <slot name="addonAfter"></slot>
    </template>
    <template slot="addonBefore">
      <slot name="addonBefore"></slot>
    </template>
    <template slot="suffix">
      <slot name="suffix"></slot>
    </template>
    <template slot="prefix">
      <slot name="prefix"></slot>
    </template>
  </a-input>
</template>

<script>
  export default {
    name: 'ptInput',
    props:{
      value:{
        type:String,
      },
      placeholder:{
        type:String,
        default:null,
      }
    },
    data() {
      return {
        inputValue:this.value
      }
    },
    watch:{
      value (val) {
        this.inputValue = val
      },
      inputValue(newValue){
        this.$emit("input",newValue)
      }
    },
    mounted() {
    },
    methods: {

    }
  }
</script>

<style scoped lang="less">
  .pt-input{
      padding: 4px !important;
  }
</style>